import { FC, JSX, useEffect, useState } from 'react'
import { useAuth } from 'react-oidc-context'
import { Link, useLocation } from 'react-router-dom'
import { isAdmin } from '../../utils/isAdmin'
import {
  BarsIcon,
  FavIcon,
  FeaturedIcon,
  MentorsIcon,
  RecentIcon,
} from '../Icons'

const viewIcon = '/images/napster_view_icon_16_16.png'

interface ISideNavProps {
  isMobile?: boolean
}

const adminMenuItems = [
  {
    label: 'Admin',
    link: '/admin/all-mentors',
    icon: <MentorsIcon />,
  },
]
const commonMenuItems = [
  {
    label: 'Featured',
    link: '/',
    icon: <FeaturedIcon />,
  },
  {
    label: 'Recent',
    link: '/recent',
    icon: <RecentIcon />,
  },
  {
    label: 'Favorites',
    link: '/favorites',
    icon: <FavIcon />,
  },
]

const napsterViewMenuItems = [
  {
    label: 'View',
    link: 'https://napster.ai/view/',
    icon: <img src={viewIcon} alt="Napster View Icon" className="w-4 h-4" />,
    externalLink: true,
  },
]

const bannerItems: {
  link: string
  icon: JSX.Element
}[] = [
  // {
  //   link: 'https://napster.ai/view/',
  //   icon: <NapsterViewBanner />,
  // },
]

const SideNav: FC<ISideNavProps> = ({ isMobile }) => {
  const { user } = useAuth()
  const location = useLocation()
  const [showMenu, setShowMenu] = useState(!isMobile)

  const handleToggleMenu = () => {
    setShowMenu(!showMenu)
  }

  const handleUpdateCookie = () => {
    window.Cookiebot?.renew()
  }

  useEffect(() => {
    if (showMenu) {
      document.body.classList.remove('tc-mv-main-nav-hidden')
      return
    }
    document.body.classList.add('tc-mv-main-nav-hidden')
  }, [showMenu])

  useEffect(() => {
    setShowMenu(!isMobile)
  }, [isMobile])

  const menuItems: {
    label: string
    link: string
    icon: JSX.Element
    externalLink?: boolean
  }[] =
    user && !!isAdmin(user)
      ? [...commonMenuItems, ...adminMenuItems, ...napsterViewMenuItems]
      : [...commonMenuItems, ...napsterViewMenuItems]

  return (
    <div>
      <button
        onClick={handleToggleMenu}
        className="flex align-middle border-0 h-10 justify-center rounded-full text-white w-10 absolute font-medium hover:backdrop-blur-[50px] hover:bg-[rgba(128,128,128,0.30)] hover:border-[rgba(255,255,255,0.40)] items-center left-[-68px] tc-mv-main-menu top-0"
        title="Main Menu"
        data-testid="main-menu-button"
      >
        <BarsIcon />
      </button>

      <div
        className={`fixed top-[72px]${isMobile ? '' : ' bottom-[80px]'} w-52 shadow-lg z-50 p-4 tc-mv-main-nav gap-2 flex flex-col overflow-y-auto ${
          showMenu ? 'block' : 'hidden'
        }`}
      >
        {menuItems.map(({ label, link, icon, ...rest }, index) => (
          <Link
            key={index}
            to={link}
            target={rest?.externalLink ? '_blank' : '_self'}
            className={`
                flex rounded-2xl h-12 items-center justify-start px-4 py-3 text-white text-lg 
                ${
                  link === location.pathname
                    ? 'tc-mv-blur border-0'
                    : 'hover:bg-hover-gray'
                }`}
          >
            {icon}
            <span className="font-medium ml-[22px]">{label}</span>
          </Link>
        ))}

        {bannerItems.length > 0 &&
          !isMobile &&
          bannerItems.map((item, index) => (
            <Link key={index} to={item.link} target="_blank">
              {item.icon}
            </Link>
          ))}
      </div>

      <div
        className={`fixed bottom-6 left-8 w-52  z-50 gap-2 hidden ${
          showMenu ? 'md:block' : 'hidden'
        }`}
      >
        <div className="flex gap-2">
          <Link
            to="https://napsterai.com/privacy"
            className="text-white text-sm underline"
            target="_blank"
            rel="noopener noreferrer"
          >
            Privacy
          </Link>
          <span className="text-white text-sm">•</span>
          <Link
            to="https://napsterai.com/terms"
            className="text-white text-sm underline"
            target="_blank"
            rel="noopener noreferrer"
          >
            Terms
          </Link>
        </div>
        <button
          className="text-white text-sm underline flex-1"
          onClick={handleUpdateCookie}
        >
          Cookie settings
        </button>
      </div>
    </div>
  )
}

export { SideNav }
